import { render, staticRenderFns } from "./robot.vue?vue&type=template&id=d7256b58&scoped=true"
var script = {}
import style0 from "./robot.vue?vue&type=style&index=0&id=d7256b58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7256b58",
  null
  
)

export default component.exports